class BypassLinks {
    container: HTMLElement;

    constructor() {
        this.container = document.querySelector('.bypass-links') || null;
    }

    click() {
        if(this.container.querySelector('.search')) {
            this.container.querySelector('.search').addEventListener('click', e => {
                e.preventDefault();
                const button: HTMLElement = document.querySelector('[data-toggle-search]');
                const searchForm: HTMLElement = document.querySelector('#header-search-form input[type="search"]');
                button.click();
                searchForm.focus();
                this.container.classList.add('visually-hidden');
            })
        }
    }

    render() {
        if(this.container) {
            this.click();
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    let bypassLinks = new BypassLinks();
    bypassLinks.render();

});